export default __webpack_public_path__ + "static/media/instaIcon.46822fda.webp";